// MAG BAG — theme.js
// Handles: qty steppers (PDP + cart), cart line-item updates, auto-add chalk

(function () {
  'use strict';

  // ── PDP qty stepper ──────────────────────────────────────────
  var qtyDisplay = document.getElementById('buy-qty-display');
  var qtyInput   = document.getElementById('buy-qty-val');

  if (qtyDisplay && qtyInput) {
    document.querySelector('.qty-minus') &&
      document.querySelector('.qty-minus').addEventListener('click', function () {
        var v = Math.max(1, parseInt(qtyInput.value) - 1);
        qtyInput.value  = v;
        qtyDisplay.textContent = v;
      });
    document.querySelector('.qty-plus') &&
      document.querySelector('.qty-plus').addEventListener('click', function () {
        var v = parseInt(qtyInput.value) + 1;
        qtyInput.value  = v;
        qtyDisplay.textContent = v;
      });
  }

  // ── Cart line-item qty + remove ──────────────────────────────
  function cartUpdate(line, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty }),
    }).then(function () { location.reload(); });
  }

  document.addEventListener('click', function (e) {
    var el = e.target;
    if (el.classList.contains('cart-qty-minus') || el.classList.contains('cart-qty-plus')) {
      cartUpdate(parseInt(el.dataset.line), parseInt(el.dataset.qty));
    }
    if (el.classList.contains('cart-remove')) {
      cartUpdate(parseInt(el.dataset.line), 0);
    }
  });

  // ── Product form: auto-add chalk + redirect ──────────────────
  // Chalk variant ID: 58598923796864 (Premium Loose Chalk 100g)
  var CHALK_VARIANT_ID = 58598923796864;

  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = productForm.querySelector('[name="add"]');
      var variantId = productForm.querySelector('[name="id"]').value;
      var qty = parseInt(productForm.querySelector('[name="quantity"]').value) || 1;

      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Adding…';
      }

      // Add MAG BAG first, then chalk, then go to cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      }).then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: CHALK_VARIANT_ID, quantity: qty })
        });
      }).then(function () {
        if (typeof fbq !== 'undefined') {
          fbq('track', 'AddToCart', {
            content_name: 'MAG BAG',
            value: 29.95 * qty,
            currency: 'EUR'
          });
        }
        window.location.href = '/cart';
      }).catch(function () {
        window.location.href = '/cart';
      });
    });
  }

  // ── Cart count refresh (for non-PDP pages) ───────────────────
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var dot = document.querySelector('.nav-cart-dot');
      if (dot) dot.textContent = '(' + cart.item_count + ')';
    });
})();